export const emptyGroup = {
    type: "group",
    operator: "AND",
    children: [],
};

export async function buildSegmentExtraFilters(vm) {
    const extraFilters = [];

    extraFilters.push({
        component: "orders",
        label: vm.t("segments-filters-orders_count"),
        name: "orders-over-period",
        options: {
            mask: "######",
        },
        removable: true,
        fullWidth: true,
    });

    if (vm.$module("quotations")) {
        extraFilters.push({
            component: "quotations",
            label: vm.t("segments-filters-quotations_count"),
            name: "quotations-over-period",
            options: {
                mask: "######",
            },
            removable: true,
        });

        extraFilters.push({
            component: "quotationsAmount",
            label: vm.t("segments-filters-quotations_amount"),
            name: "quotations-amount",
            options: {
                mask: "######",
            },
            removable: true,
        });
    }

    if (vm.$module("rfm")) {
        const rfmGroups = [
            "cant_lose",
            "champion",
            "loyal",
            "needs_attention",
            "potential_champion",
            "new",
            "promising",
            "about_to_sleep",
            "at_risk",
            "hibernating",
            "lost",
        ];
        extraFilters.push({
            component: "checkbox",
            label: vm.t("segments-filters-rfm_group"),
            name: "rfm-group",
            options: {
                options: rfmGroups.map((seg) => ({
                    value: seg,
                    label: vm.t("rfm_groups-" + seg),
                })),
                icon: "fa-tag",
            },
            removable: true,
        });
    }

    if (vm.$module("campaign_interactions")) {
        extraFilters.push({
            component: "campaignInteraction",
            label: vm.t("segments-filters-campaign_interactions"),
            name: "interaction-over-period",
            options: {
                mask: "######",
            },
            removable: true,
        });
    }

    if (vm.fields) {
        for (let key in vm.fields) {
            let field = vm.fields[key];
            if (field.type === "date") {
                extraFilters.push({
                    component: "min-max",
                    label: vm.t("segments-filters-days_after_field", [field.field_name]),
                    name: "client_field_" + field.id,
                    removable: true,
                    options: {
                        mask: "D#####",
                    },
                });
            } else if (field.type === "number") {
                extraFilters.push({
                    component: "min-max",
                    label: field.field_name,
                    name: "client_field_" + field.id,
                    removable: true,
                    options: {
                        mask: "D#####",
                    },
                });
            } else if (field.type === "text") {
                extraFilters.push({
                    component: "textfield",
                    label: field.field_name,
                    name: "client_field_" + field.id,
                    removable: true,
                });
            } else if (field.type === "user") {
                await vm.$store.dispatch("placeDetails/setPlace", vm.placeId);
                let users = vm.users.filter((u) => parseInt(u.active) === 1);
                extraFilters.push({
                    component: "selectbox",
                    label: field.field_name,
                    name: "client_field_" + field.id,
                    options: [
                        ...users.map((u) => ({
                            value: u.id,
                            label: u.name,
                        })),
                    ],
                    removable: true,
                });
            }
        }
    }

    if (vm.$module("custom_events")) {
        extraFilters.push({
            component: "customEvents",
            label: vm.t("segments-filters-custom_event"),
            name: "events-over-period",
            options: {
                mask: "######",
            },
            removable: true,
        });
    }

    extraFilters.push({
        component: "purchasedProduct",
        label: vm.t("segments-filters-purchased_product"),
        name: "purchased_product",
        options: {
            mask: "######",
        },
        removable: true,
    });

    extraFilters.push({
        component: "formResponses",
        label: vm.t("segments-filters-filled_form"),
        name: "form-responses",
        removable: true,
        fullWidth: true,
    });

    extraFilters.push({
        component: "selectbox",
        label: vm.t("segments-filters-customer_profile"),
        name: "customer-profile",
        options: [
            { value: "1", label: vm.t("segments-filters-profile_complete") },
            { value: "0", label: vm.t("segments-filters-profile_incomplete") },
            { value: "withPhone", label: vm.t("segments-filters-profile_with_phone") },
            { value: "withEmail", label: vm.t("segments-filters-profile_with_email") },
        ],
        removable: true,
    });

    if (vm.$module("rewards")) {
        extraFilters.push({
            component: "min-max",
            label: vm.t("segments-filters-points_balance"),
            name: "points-balance",
            options: {
                mask: "######",
            },
            removable: true,
            hidden: !vm.$pointsProgram(),
        });
    }

    extraFilters.push({
        component: "min-max",
        label: vm.t("segments-filters-average_ticket"),
        name: "avg-ticket",
        removable: true,
    });

    extraFilters.push({
        component: "clv",
        label: vm.t("segments-filters-clv_total_spent"),
        name: "ltv",
        removable: true,
    });

    if (vm.$store.state.place.branches.length > 1) {
        extraFilters.push({
            component: "branch",
            label: vm.t("segments-filters-branches"),
            removable: true,
            name: "branch",
        });
    }

    extraFilters.push({
        component: "min-max",
        label: vm.t("segments-filters-days_since_last_order"),
        name: "last-order-period",
        options: {
            mask: "######",
        },
        removable: true,
    });

    extraFilters.push({
        component: "min-max",
        label: vm.t("segments-filters-days_since_first_order"),
        name: "first-order-period",
        options: {
            mask: "######",
        },
        removable: true,
    });

    if (vm.$module("predictability")) {
        extraFilters.push({
            component: "min-max",
            label: vm.t("segments-filters-days_until_next_order"),
            name: "predicted-order-period",
            options: {
                mask: "D######",
            },
            removable: true,
        });
    }

    extraFilters.push({
        component: "min-max",
        label: vm.t("segments-filters-days_since_created"),
        name: "days-since-client-created",
        options: {
            mask: "######",
        },
        removable: true,
    });

    extraFilters.push({
        component: "min-max",
        label: vm.t("segments-filters-age"),
        name: "age",
        options: {
            mask: "######",
        },
        removable: true,
    });

    extraFilters.push({
        component: "birthdate",
        label: vm.t("segments-filters-birthday_month"),
        name: "month-birthdate",
        removable: true,
    });

    extraFilters.push({
        component: "communicationChannels",
        label: vm.t("segments-filters-communication_channels"),
        name: "communication-channels",
        removable: true,
    });

    return extraFilters;
}
